// Mesmo contrato da rotina Usuários, limitado à empresa do cabeçalho.
export async function loadGridLayoutUsers(vm, companyId) {
  const users = new Map(), seenPages = new Set()
  for (let page = 0; page < 50; page++) {
    const { data } = await vm.$axios.get(vm.$store.state.urlRest + 'user', { headers: { 'X-Company-Id': companyId }, params: { value: null, filter: 'ALL', page, size: 200 }, timeout: 8000 })
    const rows = Array.isArray(data) ? data : data?.content
    if (!Array.isArray(rows)) throw Error('Resposta de usuários inválida.')
    const fingerprint = rows.map(user => user.id).join(',')
    if (rows.length && seenPages.has(fingerprint)) throw Error('A consulta repetiu uma página de usuários. Tente novamente.')
    seenPages.add(fingerprint)
    for (const user of rows) if (user.id != null) users.set(String(user.id), { id: String(user.id), name: user.fullName || user.name || user.nome || `Usuário ${user.id}` })
    if (Array.isArray(data) || data.last === true || rows.length < 200 || (Number.isFinite(data.totalPages) && page + 1 >= data.totalPages)) return [...users.values()]
  }
  throw Error('A listagem de usuários excedeu o limite de consulta. Refine o cadastro antes de configurar acessos.')
}
